module.exports = __webpack_public_path__ + "img/apple.820449d.svg";